import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { MapArchiveService, NotificationService } from '@services';
import { catchError, of } from 'rxjs';

import { MapArchiveEntry } from '@models';

export const mapArchiveResolver: ResolveFn<MapArchiveEntry | null> = (
  route: ActivatedRouteSnapshot,
) => {
  const mapArchiveService = inject(MapArchiveService);
  const notificationService = inject(NotificationService);
  const router = inject(Router);

  const mapId = route.paramMap.get('id');
  if (!mapId) {
    return of(null);
  }

  return mapArchiveService.getMap(mapId).pipe(
    catchError((err) => {
      console.error(err);

      switch (err?.status) {
        case 401:
          break;
        default:
          router.navigate(['/404'], {
            skipLocationChange: true,
          });
          notificationService.error('Failed to load the requested map.');
          break;
      }

      return of(null);
    }),
  );
};
